<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import Qs from 'qs'
  import URL from '@/api/im/url'
  import DateUtil from "@/utils/IM/tradeDataUtil";
  let userList = {}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    mounted() {
      this.axios.post(URL.call.customer.getServiceUser,  {pageNum: 1, pageSize: 1000},{headers:{'Content-Type': 'application/json'}}).then(res => {
        //console.log(res);
        if (res.code == 0 && res.result){
          let arr = res.result.list;
          for (let i in arr) {
            userList[arr[i].userName] = arr[i].displayName;
          }
          this.$refs.childTable.defaultGetData(this.queryData);
        }
      })
      this.axios.post(URL.call.servicedutysetting.list).then(res => {
        if (res.code == 0){
          let arr = res.result;
          for (let i in arr) {
            this.updateData.cols.push(
              { title: arr[i].name+'('+arr[i].start+'-'+arr[i].end+')', field: 'key'+arr[i].id,type:2,optionList:userList,multiple:true,required:true}
            );
            this.pageData.cols.push(
              { title: arr[i].name+'('+arr[i].start+'-'+arr[i].end+')', field:'key'+arr[i].id,render:(data,full)=>{
                  if (!full.detail) return '';
                  let json = JSON.parse(full.detail);
                  let users = json['key'+arr[i].id];
                  if (!users) return "";
                  let user = users.split(",");
                  let result = [];
                  for (const i in user) {
                    result.push(userList[user[i]]);
                  }
                  return result.join(",");
                }}
            );
          }
          this.pageData.cols.push(
            {title: '操作',btnClick:[
                {name: '修改',click:"update",type:"primary",icon:"el-icon-edit"},
                {name: '删除',click:"delete",type:"primary",icon:"el-icon-delete"},
                {name: '复制',click:"copy",type:"primary",icon:"el-icon-edit"},
              ]
            },
          );
        }
      })
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update" || clickName == "copy"){
          let detail = JSON.parse(row.detail);
          let obj = {};
          for (let i in detail) {
             if (i.startsWith("key")) {
               obj[i] = detail[i].split(",");
             }
          }
          row = Object.assign(row,obj);
          row.date = row.date.toString();
          if (clickName == "copy") {
            row.id = null;
          }
          this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
          this.dataChanage(URL.call.serviceduty.del,{id:row.id},res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$refs.childUpdate.close();
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultGetData(this.queryData);
        }else if("新增" == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        let detail = {};
        for (let i in model) {
           if (i.startsWith("key")){
             detail[i] = model[i].join(",");
           }
        }
        model.detail = JSON.stringify(detail);
        //根据是否包含id更新还是添加
        this.dataChanage(URL.call.serviceduty.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: 'id', field: 'id',hidden:true},
            { title: '值班日期', field: 'date',type: 5,dateType:'date',format:'yyyyMMdd',required:true},
            //{ title: '早班(07:00:00-12:00:00)', field: 'key1',type:2,optionList:userList,multiple:true},
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: '开始日期', field: 'startDate',type:5,dateType:'date',format:'yyyyMMdd',data: DateUtil.formatDate(new Date().getTime(),"yyyyMMdd")},
              { title: '结束日期', field: 'endDate',type:5,dateType:'date',format:'yyyyMMdd'},
              {click:"查询"},
              {click:"新增"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.call.serviceduty.list, //请求路径和参数
          sequence: true,
          isPage: false,
          cols: [
            { title: '主键', field: 'id'},
            { title: '值班日期', field: 'date',render:(data,full)=>{
                let str = data.toString();
                return str.substring(0,4) + "-" + str.substring(4,6)+ '-' +str.substring(6,8);
              }},
            /*{ title: '早班(07:00:00-12:00:00)', field: 'key1',render:(data,full)=>{
                if (!full.detail) return '';
                let json = JSON.parse(full.detail);
                let users = json["key1"];
                if (!users) return "";
                let arr = users.split(",");
                let result = [];
                for (const i in arr) {
                  result.push(userList[arr[i]]);
                }
                return result.join(",");
              }},*/
            //{ title: '排班详情 {班次1:"客服1,客服二",班次2:"客服1,客服二"}', field: 'detail'},
            /*{title: '操作',width: 200,btnClick:[
                {name: '拨打',click:"call",type:"primary",icon:"el-icon-edit"},
                {name: '分配客服',click:"setServiceUser",type:"primary",icon:"el-icon-edit",hidden:(data,full)=>{
                    return this.$route.path.indexOf(serviceSign) >= 0;
                  }},
              ]
            },*/
          ]
        }
      }
    }
  }
</script>
